import {
  Label,
  Select,
  SelectAction,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectValue,
} from 'keep-react'

export const FormSelect = ({
  formik,
  label,
  name,
  options = [],
  allowEmpty,
  placeholder,
  required,
  inline,
  extraClasses,
  onChange,
}: {
  formik: any
  label: string
  name: string
  options: Array<{ label: string; value: string | number }> | undefined
  allowEmpty: boolean
  required?: boolean
  extraClasses?: string
  inline?: boolean
  placeholder?: string
  onChange?: (val?: any) => void
}) => {
  const { error } = formik.getFieldMeta(name)

  return (
    <div className="flex flex-col">
      <div
        className={`relative w-full ${inline ? 'items-center' : ''} ${
          extraClasses ?? ''
        }`}
      >
        {label && (
          <Label className={`text-body-4 block ${inline ? 'w-[40%]' : 'pb-2'}`}>
            {required && <span className="text-primary-600">*</span>}
            {label}
          </Label>
        )}
        <Select
          name={name}
          onValueChange={(val: any) => {
            if (onChange) {
              onChange(val)
            } else {
              formik.setFieldValue(name, val)
            }
          }}
          value={formik.values[name]}
        >
          <SelectAction
            className={`text-body-4 text-black px-2 w-full  ${
              error ? 'border-error-600' : ''
            }  disabled:bg-metal-100 disabled:cursor-not-allowed [&_span]:truncate`}
          >
            <SelectValue placeholder={placeholder} />
          </SelectAction>

          <SelectContent>
            <SelectGroup>
              {allowEmpty && <SelectLabel>{placeholder}</SelectLabel>}

              {options.map(({ label, value }) => (
                <SelectItem value={String(value)} key={value}>
                  {label}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
      {error && (
        <span className="py-2 block w-full text-body-5 text-error-600">
          {error}
        </span>
      )}
    </div>
  )
}
